module.exports = __webpack_public_path__ + "static/codigo_kid_logo-063d95e697a7952002501d1dbd51e6c2.png";